import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import personalityPNG from '~/assets/images/communication/personality.png'
import personalityWEBP from '~/assets/images/communication/personality.webp'
import { CommunicationSingleSelectStyles as S } from '~/pages/communication/libs/communicationSingleSelectStyles'
import { parseEmojiOption } from '~/pages/communication/libs/parseEmojiOption'
import {
  PERSONALITY_OPTIONS,
  PERSONALITY_QUESTION,
} from '~/pages/communication/personality/libs/components/PersonalityCommunication/constants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const PersonalityCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: PERSONALITY_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationPersonality.title"
            />
          </S.Title>
        </S.TitleGroup>

        <S.ImageWrapper>
          <picture>
            <source srcSet={personalityWEBP} type="image/webp" />
            <img src={personalityPNG} alt="What do you consider yourself?" />
          </picture>
        </S.ImageWrapper>

        <S.Options>
          {PERSONALITY_OPTIONS.map(({ key, i18nKey }) => {
            const { emoji, label } = parseEmojiOption(
              t(`onboarding.communicationPersonality.options.${i18nKey}`),
            )

            return (
              <S.OptionButton
                key={key}
                type="button"
                $isSelected={answer === key}
                disabled={isAnswersDisabled}
                onClick={() => {
                  if (isAnswersDisabled) return
                  setAnswer(key)
                  handleChange(key, handleContinue)
                  setIsAnswersDisabled(true)
                }}
              >
                <S.OptionEmoji>{emoji}</S.OptionEmoji>
                <S.OptionLabel>{label}</S.OptionLabel>
              </S.OptionButton>
            )
          })}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default PersonalityCommunication
